import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSidepanelWrapper from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidepanel-wrapper/grossing-touch-sidepanel-wrapper.vue'

@Component({
    components: {
        GrossingTouchSidepanelWrapper
    }
})

export default class GrossingTouchIncidentsSidepanel extends Vue {
    private grossingIncidents !: Array<object>

    constructor() {
        super()
        this.grossingIncidents = [
            {
                incId: 'INC-H322-000928',
                incDate: '17/03/2022 12:34',
                incType: 'Imposibilidad de realizar corte por defectos en el bloque'
            },
            {
                incId: 'INC-H322-000929',
                incDate: '17/03/2022 12:36',
                incType: 'Imposibilidad de realizar corte por defectos en el bloque'
            }
        ]
    }
}
